import { createContext } from 'react';
export var PageContext = /*#__PURE__*/createContext({});